import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar';
import PageTitle from '../../components/pagetitle';
import About from '../../components/aboutfull';
import FunFact from '../../components/FunFact';
import Attorney from '../../components/attorneys';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';
import Logo from '../../images/logo.svg';

import SEO from '../../SEO';
import { getRouteMeta } from '../../seo/routes';

const AboutPage = () => {
  return (
    <Fragment>
      <SEO {...getRouteMeta('/quienes-somos')} />
      <Navbar
        hclass={'wpo-header-style-2'}
        Logo={Logo}
        topbarNone={'header-without-topbar'}
      />
      <PageTitle pageTitle={'Acerca De Nosotros'} pagesub={'Quiénes Somos'} />
      <About />
      <FunFact />
      <Attorney />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default AboutPage;
